import React, { useEffect,useState } from 'react';
import { getSingleWidgetDetail } from "../../../../staticWidgets/utils/CommonWidgetApi";
import { getTemplateDetail, getDefaultList } from "../../../../utils/teamShowcaseApi";
import DetailPopup from "./DetailPopup";

const DedicatedTeamTemplateWidget = ({selectedTemplate,isTemplateId,widgetId,teamShowcaseTabData,refreshWidgetList }) => {
    const [apiData, setApiData] = useState(false);
    const [selectedMember, setSelectedMember] = useState(null);
    const [showModal, setShowModal] = useState(false);


    const {
        is_website_frontend,
        is_show_header,
        header_title,
        header_caption,
        is_call_to_action,
        call_to_action_title,
        call_to_action_button_text,
        call_to_action_button_link,
        layout_is_full_width,
        layout_custom_width,
        text_align_type,
        message_text_type,
        member_background_color,
        text_color,
        links_color,
        call_to_action_button_color,
        widget_background_color,
        widget_title_color,
        widget_caption_color,
        widget_title_size,
        widget_caption_size,
        widget_align_type,
        popup_background_color,
        popup_text_color,
        popup_links_color,
    } = teamShowcaseTabData || {};

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/team-showcase/temp-css/TeamShowcase.css`;
        if (widgetId) {
            link.setAttribute("team-showcase-data-dynamic-css", "team-showcase");
        } else {
            link.setAttribute("data-dynamic-css", "team-showcase");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="team-showcase"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (isTemplateId) {
                    const result = await getTemplateDetail(isTemplateId);
                    setApiData(result);
                } else if (widgetId) {
                    const result = await getSingleWidgetDetail(widgetId);
                    setApiData(result);
                } else {
                    const result = await getDefaultList();
                    setApiData(result); 
                }
            } catch (error) {
                // console.error("Error fetching data:", error);
            }
        };

        if (isTemplateId !== undefined || widgetId !== undefined) {
            fetchData();
        }
    }, [isTemplateId, widgetId, refreshWidgetList]);

    // Utility function to chnage text color
    const getContrastColor = (bgColor) => {
        if (!bgColor) return '#000'; 

        // Remove # if exists
        const color = bgColor.replace('#', '');

        // Convert 3-digit to 6-digit hex
        const fullHex = color.length === 3
            ? color.split('').map(char => char + char).join('')
            : color;

        const r = parseInt(fullHex.substr(0, 2), 16);
        const g = parseInt(fullHex.substr(2, 2), 16);
        const b = parseInt(fullHex.substr(4, 2), 16);

        // Calculate luminance
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;

        // Return black or white based on brightness
        return brightness > 125 ? '#000' : '#fff';
    };

    //Custome responsive width calculation
    const calculateResponsiveWidth = (layout_custom_width) => {
        if (layout_custom_width > 1280 && layout_custom_width < 1921) return '25%';
        if (layout_custom_width > 840 && layout_custom_width < 1280) return '33.33%';
        if (layout_custom_width > 540 && layout_custom_width < 840) return '50%';
        if (layout_custom_width > 0 && layout_custom_width < 540) return '100%'; 
        return '25%';
    };

    return (
        <>
            <div className={`upgadeify team_showcase dedicated-team-temp ${is_website_frontend}`} style={{
                backgroundColor: widget_background_color,
                ...(Number(layout_is_full_width) === 0 && {
                    maxWidth: layout_custom_width + 'px',
                    margin: '0 auto',
                }),
            }}>
            {apiData?.data?.data_list?.length > 0 ? (
            <>
                {Number(is_show_header) === 1 && (
                    <>
                    {header_title && (
                        <h2 className='team_showcase_main_title' style={{ color: widget_title_color,fontSize: widget_title_size, textAlign: widget_align_type, }}>{header_title}</h2>
                    )}
                    {header_caption && (
                        <p className='header-caption' style={{ color: widget_caption_color,fontSize: widget_caption_size,textAlign: widget_align_type, }}>{header_caption}</p>
                    )}
                    </>
                )}
                <div className='team_showcase_inner'>
                    {/*<h3 className="team__showcase_title">Leadership</h3>*/}
                    <div className='team_showcase_main_grid'>
                        {apiData.data.data_list.map((member, index) => (
                        <div className='upgrade_leaderShip' key={index} style={{ width: Number(layout_is_full_width) === 1 ? '25%' : calculateResponsiveWidth(layout_custom_width), padding: '10px' }}>
                            <div className='leaderShip' style={{ backgroundColor: member_background_color}}>
                                  {member.image && (
                                <div className={`leadership_img ${text_align_type}`} style={{ width: '100%', textAlign: text_align_type }}>
                                    <img src={member.image} alt={member.name || "Team Member"}/>
                                </div>
                            )}
                            <div className='leadership_text'>
                                {member.name && (
                                    <h3 className='team_showcase_name' style={{ color: text_color, textAlign: text_align_type }}>{member.name}</h3>
                                )}
                                {member.position && (
                                    <span className='team_showcase_job' style={{ color: text_color, textAlign: text_align_type }}>{member.position}</span>
                                )}
                                {member.phone && (
                                    <span className='team_showcase_job' style={{ color: text_color,textAlign: text_align_type }}>{member.phone}</span>
                                )}
                                {member.email && (
                                    <>
                                    {member.email && member.email.trim() !== '' ? (
                                        <a
                                            className='team_showcase_mail'
                                            href={`mailto:${member.email.trim()}`}
                                            style={{ color: links_color,textAlign: text_align_type }}
                                        >
                                            {member.email.trim()}
                                        </a>
                                        ) : null
                                    }
                                    </>
                                )}
                                {member.location && (
                                    <span className='team_showcase_job' style={{ color: links_color,textAlign: text_align_type }}>{member.location}</span>
                                )}
                                {member.website && (
                                    <span className='team_showcase_job' style={{ color: links_color,textAlign: text_align_type }}>{member.website}</span>
                                )}
                                

                                {message_text_type && (
                                    <button className={`team_showcase_see_btn ${text_align_type}`} 
                                        onClick={() => {
                                            setSelectedMember(member);
                                            setShowModal(true);
                                        }} style={{ color: text_color }}>
                                        {message_text_type}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8" className="MemberCardSeeMore__Icon-sc-7faa8c38-1 bOEgUR eapp-team-showcase-member-card-see-more-componentIcon">
                                        <path transform="translate(-64 -5)" d="M72.043 8.25l-2.147-2.146a.5.5 0 0 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708l2.147-2.146H65.25a.5.5 0 1 1 0-1h6.793z"></path>
                                        </svg>
                                    </button>
                                )}
                            </div>
                            </div>    
                        </div>
                        ))}
                    </div>
                </div>
                {Number(is_call_to_action) === 1 && (
                    <>
                        <div className='team_showcase_footer'>
                            {call_to_action_title && (
                                <p style={{ color: text_color }}>{call_to_action_title}</p>
                            )}
                            {call_to_action_button_text && (
                                <a className='btn btn_team_showcase' 
                                    href={call_to_action_button_link?.trim() !== '' ? call_to_action_button_link : 'https://dashboard.upgadeify.com/'}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    style={{
                                        backgroundColor: call_to_action_button_color,
                                        color: getContrastColor(call_to_action_button_color),
                                    }}
                                    >
                                        {call_to_action_button_text}
                                </a>
                            )}
                        </div>
                        </>
                    )}
                    {selectedMember && showModal && (
                        <DetailPopup 
                            selectedMember={selectedMember} 
                            onClose={() => setShowModal(false)} 
                            popup_background_color={popup_background_color}
                            popup_text_color={popup_text_color}
                            popup_links_color={popup_links_color}
                        />
                    )}
                </>
                ) : (
                    <div className="loader-container">
                        <div className="spinner"></div>
                        <p>Loading please wait...</p>
                    </div>
                )}
            </div>
        </>
    );
};

export default DedicatedTeamTemplateWidget;
